import * as ActionTypes from './actionType';
import asyncActionCreator from '../../../utils/asyncActionCreator';
import API from '../../../API/api'

/**
 * 获得题目列表
 * **/
const getQuestionListRequest = () => ({
    type: ActionTypes.getQuestionListRequest,
    payload: {}
});
const getQuestionListSuccess = (data) => ({
    type: ActionTypes.getQuestionListSuccess,
    payload: { data }
});

const getQuestionListFailure = (error) => ({
    type: ActionTypes.getQuestionListFailure,
    payload: { error }
});


export const getAllQuestionList = (pager,callback) => asyncActionCreator(//全部题目列表
    API.GET_ALL_LIST,
    getQuestionListRequest,
    getQuestionListSuccess,
    getQuestionListFailure,
    'POST',
    pager,
    callback,
    false,
);


export const getEntryingQuestionList = (pager,callback) => asyncActionCreator(//未审核列表
    API.GET_ENTRYING_LIST,
    getQuestionListRequest,
    getQuestionListSuccess,
    getQuestionListFailure,
    'POST',
    pager,
    callback,
    false,
);
export const getPassQuestionList = (pager,callback) => asyncActionCreator(//审核通过列表
    API.GET_PASS_LIST,
    getQuestionListRequest,
    getQuestionListSuccess,
    getQuestionListFailure,
    'POST',
    pager,
    callback,
    false,
);
export const getReworkQuestionList = (pager,callback) => asyncActionCreator(//返工列表
    API.GET_REWORK_LIST,
    getQuestionListRequest,
    getQuestionListSuccess,
    getQuestionListFailure,
    'POST',
    pager,
    callback,
    false,
);







// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_detail/action.js